import { Injectable } from '@angular/core';
import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(private settingsService: SettingsService) {}

  private getBrowserLocales(options = {}) {
    const defaultOptions = {
      languageCodeOnly: false,
    };

    const opt = {
      ...defaultOptions,
      ...options,
    };

    const browserLocales =
      navigator.languages === undefined
        ? [navigator.language]
        : navigator.languages;

    if (!browserLocales) {
      return undefined;
    }

    return browserLocales.map((locale) => {
      const trimmedLocale = locale.trim();

      return opt.languageCodeOnly
        ? trimmedLocale.split(/-|_/)[0]
        : trimmedLocale;
    });
  }

  getBrowserPreferredLanguage() {
    const result = this.getBrowserLocales({ languageCodeOnly: false });
    if (result && result.length) {
      return result[0];
    } else {
      return 'en-US';
    }
  }

  getAppLanguage() {
    const langParam = this.settingsService.settings.lang;
    return langParam || this.getBrowserPreferredLanguage();
  }
}
